export default "__VITE_ASSET__C0Arqxy6__"